module.exports = __webpack_public_path__ + "daa70b0671e530871fadd8e59d1071e6.pdf";